module.exports = __webpack_public_path__ + "media/src/images/balloons/white_gradient-f91e0ae980f6331b5f270b13d8a1ff6a.png";